import { render, staticRenderFns } from "./foot.vue?vue&type=template&id=12b3ea86&scoped=true&"
import script from "./foot.vue?vue&type=script&lang=js&"
export * from "./foot.vue?vue&type=script&lang=js&"
import style0 from "./foot.vue?vue&type=style&index=0&id=12b3ea86&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b3ea86",
  null
  
)

export default component.exports